module.exports = __webpack_public_path__ + "static/img/10007 (3).d59b83f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10007 (3).webp
// module id = /D/h
// module chunks = 14